import React from "react";
import { Link } from "react-router-dom";

/**
 * Marketing footer (redesign shell): 4-column grid
 * (brand+blurb+socials / Explore / Visit & Shop / Visit Us) + bottom bar.
 * Collapses to one column ≤1080px. Styling lives in marketing.css (.umr).
 */
export default function SiteFooter() {
  return (
    <footer className="u-footer">
      <div className="u-foot">
        <div>
          <img src="/design/assets/umoona-emblem.png" alt="Umoona Opal Mine & Museum" className="u-foot__mark" loading="lazy" decoding="async" />
          <p className="u-foot__blurb">
            Coober Pedy's largest single underground tourist attraction. Family-owned and worked since the 1920s.
          </p>
          <div className="u-foot__social">
            <a
              href="https://www.facebook.com/umoona"
              target="_blank"
              rel="noreferrer"
              className="u-foot__socialbtn"
              aria-label="Facebook"
            >
              <svg viewBox="0 0 24 24" width="17" height="17" fill="#fff">
                <path d="M13.5 21v-8h2.6l.4-3.1h-3V7.9c0-.9.25-1.5 1.55-1.5H16.6V3.7c-.3 0-1.3-.13-2.45-.13-2.43 0-4.1 1.48-4.1 4.2v2.24H7.4V13h2.65v8z" />
              </svg>
            </a>
            <a
              href="https://www.instagram.com/umoonaopal"
              target="_blank"
              rel="noreferrer"
              className="u-foot__socialbtn"
              aria-label="Instagram"
            >
              <svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="#fff" strokeWidth="2">
                <rect x="3" y="3" width="18" height="18" rx="5.2" />
                <circle cx="12" cy="12" r="4.1" />
                <circle cx="17.3" cy="6.7" r="1.15" fill="#fff" stroke="none" />
              </svg>
            </a>
          </div>
        </div>

        <div>
          <div className="u-foot__head">Explore</div>
          <div className="u-foot__links">
            <Link to="/about-opal">About Opal</Link>
            <Link to="/coober-pedy">Coober Pedy</Link>
            <Link to="/free-museum">Free Museum</Link>
            <Link to="/underground-tours">Underground Tours</Link>
            <Link to="/webcam">Webcams</Link>
          </div>
        </div>

        <div>
          <div className="u-foot__head">Visit &amp; Shop</div>
          <div className="u-foot__links">
            <Link to="/book-tour">Book a Tour</Link>
            <Link to="/group-tours">Group &amp; School Tours</Link>
            <Link to="/group-accommodation">Group Accommodation</Link>
            <Link to="/opal-store">The Opal Store</Link>
            <Link to="/online-store">Shop Online</Link>
            <Link to="/contact">Contact Us</Link>
          </div>
        </div>

        <div>
          <div className="u-foot__head">Visit Us</div>
          <div className="u-foot__contact">
            14 Hutchison St
            <br />
            Coober Pedy SA 5723
            <br />
            <a href="tel:+61886725288">(08) 8672 5288</a>
            <br />
            <a href="mailto:admin@umoonaopalmine.com.au">admin@umoonaopalmine.com.au</a>
            <br />
            <span className="u-foot__hours">Open daily · 8:30am – 5:30pm</span>
          </div>
        </div>
      </div>

      <div className="u-foot__bottom">
        <span>© 2026 Umoona Opal Mine &amp; Museum. Coober Pedy's iconic underground experience.</span>
        <a href="https://www.turbo.net.au" target="_blank" rel="noreferrer">
          Website by Turbo
        </a>
      </div>
    </footer>
  );
}
